import dayjs from 'dayjs';

import type { RecentAsset } from '@/shared/types/recentAssets';

const STORAGE_KEY = 'cyclone_recent_assets';
export const MAX_ITEMS = 20;
const DATA_RETENTION_MONTHS = 3;

export const getRecentAssets = (): RecentAsset[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    const allItems = JSON.parse(stored) as RecentAsset[];
    if (!Array.isArray(allItems)) return [];

    const threeMonthsAgo = dayjs().subtract(DATA_RETENTION_MONTHS, 'months');
    const recentItems = allItems.filter((item) => dayjs(item.viewedAt).isAfter(threeMonthsAgo));

    return recentItems.sort((a, b) => dayjs(b.viewedAt).valueOf() - dayjs(a.viewedAt).valueOf());
  } catch (error) {
    console.error('Failed to load recent assets from localStorage:', error);
    throw error;
  }
};

export const addRecentAsset = (asset: RecentAsset): void => {
  try {
    const currentItems = getRecentAssets();
    const filteredItems = currentItems.filter((item) => item.id !== asset.id);

    const newAsset: RecentAsset = {
      ...asset,
      viewedAt: asset.viewedAt || dayjs().toISOString(),
    };

    const updatedItems = [newAsset, ...filteredItems];
    const limitedItems = updatedItems.slice(0, MAX_ITEMS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(limitedItems));
  } catch (error) {
    console.error('Failed to save recent asset to localStorage:', error);
    throw error;
  }
};

export const clearRecentAssets = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear recent assets from localStorage:', error);
    throw error;
  }
};

export const removeRecentAsset = (assetId: string): void => {
  try {
    const currentItems = getRecentAssets();
    const filteredItems = currentItems.filter((item) => item.id !== assetId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredItems));
  } catch (error) {
    console.error('Failed to remove recent asset from localStorage:', error);
    throw error;
  }
};
